define(["react","underscore","prop-types","@bingads-webui-universal/primitive-utilities","react-router-dom","query-string"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__41__, __WEBPACK_EXTERNAL_MODULE__176__, __WEBPACK_EXTERNAL_MODULE__987__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 984);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__176__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__41__;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(985);


/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "$current", {
  enumerable: true,
  get: function get() {
    return _queryParam.$current;
  }
});
Object.defineProperty(exports, "QueryParam", {
  enumerable: true,
  get: function get() {
    return _queryParam.QueryParam;
  }
});
Object.defineProperty(exports, "withScope", {
  enumerable: true,
  get: function get() {
    return _withScope.withScope;
  }
});
Object.defineProperty(exports, "DefaultScopeProvider", {
  enumerable: true,
  get: function get() {
    return _defaultScopeProvider.DefaultScopeProvider;
  }
});
Object.defineProperty(exports, "scopeFormatter", {
  enumerable: true,
  get: function get() {
    return _scopeFormatter.scopeFormatter;
  }
});
Object.defineProperty(exports, "ScopeContext", {
  enumerable: true,
  get: function get() {
    return _scopeContext.ScopeContext;
  }
});
Object.defineProperty(exports, "withQueryString", {
  enumerable: true,
  get: function get() {
    return _withQueryString.withQueryString;
  }
});

var _queryParam = __webpack_require__(986);

var _withScope = __webpack_require__(988);

var _defaultScopeProvider = __webpack_require__(990);

var _scopeFormatter = __webpack_require__(994);

var _scopeContext = __webpack_require__(989);

var _withQueryString = __webpack_require__(995);

/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryParam = exports.$current = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _queryString = _interopRequireDefault(__webpack_require__(987));

var _primitiveUtilities = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const $current = '$current';
exports.$current = $current;

function filterByKeys(params, allowedKeys) {
  return _underscore.default.isEmpty(allowedKeys) ? params : _underscore.default.pick(params, allowedKeys);
}

class QueryParam {
  static get Empty() {
    return new QueryParam({}, {
      saveScope: _underscore.default.noop
    });
  }

  constructor(location, history, saveScope, processor = _underscore.default.identity, allowedKeys = []) {
    _defineProperty(this, "append", params => {
      const allowedParams = filterByKeys(params, this.allowedKeys);
      this.values = _underscore.default.defaults(_underscore.default.omit(allowedParams, val => val === $current), this.values);
    });

    _defineProperty(this, "remove", keys => {
      const removeKeys = _underscore.default.isArray(keys) ? keys : [keys];
      const filteredKeys = _underscore.default.isEmpty(this.allowedKeys) ? keys : _underscore.default.intersection(_underscore.default.flatten(removeKeys), this.allowedKeys);
      this.values = _underscore.default.omit(this.values, filteredKeys);
    });

    _defineProperty(this, "set", params => {
      this.values = this.getMerged(params);
    });

    _defineProperty(this, "getMerged", params => {
      const allowedParams = filterByKeys(params, this.allowedKeys);

      const newParams = _underscore.default.mapObject(allowedParams, (val, key) => val === $current ? _underscore.default.result(this.values, key, '') : val);

      const unmanagedParams = _underscore.default.isEmpty(this.allowedKeys) ? {} : _underscore.default.omit(this.values, this.allowedKeys);
      return _underscore.default.extend(unmanagedParams, newParams);
    });

    _defineProperty(this, "parse", (query = this.location.search) => {
      this.values = this.processor(_queryString.default.parse(query));
    });

    _defineProperty(this, "stringify", (values = this.values) => _queryString.default.stringify(values, {
      sort: false
    }));

    _defineProperty(this, "isEqual", search => _underscore.default.isEqual(_queryString.default.parse(this.stringify()), _queryString.default.parse(search)));

    _defineProperty(this, "save", pathname => {
      if (this.saveScope(this, pathname)) {
        this.saveState();
        return true;
      }

      this.restoreState();
      return false;
    });

    _defineProperty(this, "saveState", () => {
      this.prevState = (0, _primitiveUtilities.cloneDeep)(this.values);
    });

    _defineProperty(this, "restoreState", () => {
      if (this.prevState) {
        this.values = this.prevState;
      }
    });

    this.processor = processor;
    this.saveScope = saveScope;
    this.allowedKeys = allowedKeys;
    this.location = location;
    this.history = history;
    this.parse();
    this.saveState();
  }

}

exports.QueryParam = QueryParam;

/***/ }),

/***/ 987:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__987__;

/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withScope = withScope;

var _react = _interopRequireDefault(__webpack_require__(3));

var _scopeContext = __webpack_require__(989);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function withScope(Component) {
  return props => _react.default.createElement(_scopeContext.ScopeContext.Consumer, null, ({
    scope
  }) => _react.default.createElement(Component, _extends({}, props, {
    scope: scope
  })));
}

/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScopeContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ScopeContext = _react.default.createContext({
  defaults: {},
  allowedKeys: []
});

exports.ScopeContext = ScopeContext;

/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScopeProvider = ScopeProvider;
exports.DefaultScopeProvider = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _verifyRouter = __webpack_require__(991);

var _defaultParamProvider = __webpack_require__(992);

var _scopeUpdater = __webpack_require__(993);

var _scopeFormatter = __webpack_require__(994);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ScopeProvider({
  location,
  history,
  scope,
  allowedKeys,
  updateQuery,
  paramFormatter,
  children,
  updateOnPathChange
}) {
  return _react.default.createElement(_defaultParamProvider.DefaultParamProvider, {
    defaults: updateQuery ? null : scope,
    allowedKeys: allowedKeys,
    paramFormatter: paramFormatter,
    location: location,
    history: history,
    updateOnPathChange: updateOnPathChange
  }, updateQuery ? _react.default.createElement(_scopeUpdater.ScopeUpdater, {
    defaults: scope
  }) : null, children);
}

const _DefaultParamProvider = _defaultParamProvider.DefaultParamProvider.propTypes,
      scopeType = _DefaultParamProvider.defaults,
      allowedKeysType = _DefaultParamProvider.allowedKeys;
ScopeProvider.propTypes = {
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string.isRequired,
    search: _propTypes.default.string.isRequired
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }),
  scope: scopeType,
  allowedKeys: allowedKeysType,
  updateQuery: _propTypes.default.bool,
  paramFormatter: _propTypes.default.func,
  updateOnPathChange: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired
};
ScopeProvider.defaultProps = {
  location: undefined,
  history: undefined,
  scope: _defaultParamProvider.DefaultParamProvider.defaultProps.defaults,
  allowedKeys: _defaultParamProvider.DefaultParamProvider.defaultProps.allowedKeys,
  updateQuery: true,
  updateOnPathChange: true,
  paramFormatter: _scopeFormatter.scopeFormatter
};
const DefaultScopeProvider = (0, _verifyRouter.verifyRouter)(ScopeProvider);
exports.DefaultScopeProvider = DefaultScopeProvider;

/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyRouter = verifyRouter;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _reactRouterDom = __webpack_require__(176);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function verifyRouter(Component) {
  const ComponentWithRouter = (0, _reactRouterDom.withRouter)(Component);

  const RouterWrapper = props => {
    const location = props.location,
          history = props.history;

    if (_underscore.default.isEmpty(location) || _underscore.default.isEmpty(history)) {
      return _react.default.createElement(ComponentWithRouter, props);
    }

    return _react.default.createElement(Component, props);
  };

  RouterWrapper.propTypes = {
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string,
      search: _propTypes.default.string
    }),
    history: _propTypes.default.shape({
      push: _propTypes.default.func
    })
  };
  RouterWrapper.defaultProps = {
    location: undefined,
    history: undefined
  };
  return RouterWrapper;
}

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultParamProvider = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _scopeContext = __webpack_require__(989);

var _queryParam = __webpack_require__(986);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const isScopeChanged = (search, scope) => !scope.isEqual(search);

const getNewState = (defaults, location, history, allowedKeys, paramFormatter, saveScope) => {
  const scope = new _queryParam.QueryParam(location, history, saveScope, paramFormatter, allowedKeys);

  _underscore.default.defaults(scope.values, defaults);

  return {
    scope,
    saveScope
  };
};

class DefaultParamProvider extends _react.default.PureComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "saveScope", (scope, pathname = this.props.location.pathname) => {
      const _this$props = this.props,
            defaults = _this$props.defaults,
            location = _this$props.location,
            history = _this$props.history,
            allowedKeys = _this$props.allowedKeys,
            paramFormatter = _this$props.paramFormatter,
            updateOnPathChange = _this$props.updateOnPathChange;
      const newLocation = {
        pathname,
        search: scope.stringify()
      };
      const scopeChanged = isScopeChanged(location.search, scope);
      const pathChanged = pathname !== location.pathname;

      if (scopeChanged || pathChanged) {
        history.push(newLocation);
        const newState = getNewState(defaults, newLocation, history, allowedKeys, paramFormatter, this.saveScope);
        const scopeChangeAccepted = newState.scope.isEqual(history.location.search);
        const pathChangeAccepted = newState.scope.location.pathname === history.location.pathname;

        if (scopeChanged && scopeChangeAccepted || pathChanged && pathChangeAccepted && updateOnPathChange) {
          this.setState(newState); // if changes were needed return `true` to signal that the request could be processed

          return true;
        } // if changes were needed return `false` to signal that the request could NOT be processed, e.g. due to navigation rejection


        return false;
      } // if no changes were needed return `true` to signal that the request could be processed


      return true;
    });

    const _defaults = props.defaults,
          _location = props.location,
          _history = props.history,
          _allowedKeys = props.allowedKeys,
          _paramFormatter = props.paramFormatter;
    this.state = getNewState(_defaults, _location, _history, _allowedKeys, _paramFormatter, this.saveScope);
  }

  static getDerivedStateFromProps(props, state) {
    const defaults = props.defaults,
          location = props.location,
          history = props.history,
          allowedKeys = props.allowedKeys,
          paramFormatter = props.paramFormatter,
          updateOnPathChange = props.updateOnPathChange;
    const scopeChanged = isScopeChanged(location.search, state.scope);
    const pathChanged = location.pathname !== state.scope.location.pathname;

    if (scopeChanged || updateOnPathChange && pathChanged) {
      return getNewState(defaults, location, history, allowedKeys, paramFormatter, state.saveScope);
    }

    return null;
  }

  render() {
    return _react.default.createElement(_scopeContext.ScopeContext.Provider, {
      value: {
        scope: this.state.scope
      }
    }, this.props.children);
  }

}

exports.DefaultParamProvider = DefaultParamProvider;
DefaultParamProvider.propTypes = {
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string.isRequired,
    search: _propTypes.default.string.isRequired
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string,
      search: _propTypes.default.string
    })
  }),
  defaults: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  children: _propTypes.default.node.isRequired,
  allowedKeys: _propTypes.default.arrayOf(_propTypes.default.string),
  paramFormatter: _propTypes.default.func,
  updateOnPathChange: _propTypes.default.bool
};
DefaultParamProvider.defaultProps = {
  location: undefined,
  history: undefined,
  defaults: {},
  allowedKeys: [],
  paramFormatter: _underscore.default.identity,
  updateOnPathChange: true
};

/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScopeUpdater = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _scopeContext = __webpack_require__(989);

var _defaultParamProvider = __webpack_require__(992);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Updater extends _react.default.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      scope: {},
      defaultScope: {}
    });
  }

  static getDerivedStateFromProps({
    scope,
    defaultScope
  }) {
    return {
      scope,
      defaultScope
    };
  }

  componentDidMount() {
    this.updateScope();
  }

  componentDidUpdate() {
    this.updateScope();
  }

  updateScope() {
    const _this$state = this.state,
          scope = _this$state.scope,
          defaultScope = _this$state.defaultScope;

    if (_underscore.default.find(defaultScope, (val, key) => !_underscore.default.has(scope.values, key))) {
      scope.set(_underscore.default.defaults(scope.values, defaultScope));
      scope.save();
    }
  }

  render() {
    return null;
  }

}

const ScopeUpdater = ({
  defaults
}) => _react.default.createElement(_scopeContext.ScopeContext.Consumer, null, ({
  scope
}) => _react.default.createElement(Updater, {
  scope: scope,
  defaultScope: defaults
}));

exports.ScopeUpdater = ScopeUpdater;
ScopeUpdater.propTypes = {
  defaults: _defaultParamProvider.DefaultParamProvider.propTypes.defaults
};
ScopeUpdater.defaultProps = {
  defaults: _defaultParamProvider.DefaultParamProvider.defaultProps.defaults
};

/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scopeFormatter = scopeFormatter;

var _underscore = _interopRequireDefault(__webpack_require__(9));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeFormatter(scope) {
  return _underscore.default.mapObject(scope, value => {
    const pattern = /^[0-9]+$/g;
    const SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    let isInt = _underscore.default.isString(value) ? value.match(pattern) : false;
    let intValue;

    if (isInt) {
      intValue = parseInt(value, 10);
      isInt = intValue.toString() === value && intValue <= SAFE_INTEGER;
    }

    return isInt ? intValue : value;
  });
}

/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withQueryString = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _queryParam = __webpack_require__(986);

var _verifyRouter = __webpack_require__(991);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function withQueryStringInternal(Component, propName = 'queryParams', processor = _underscore.default.identity) {
  const WrappedComponent = props => {
    const location = props.location,
          history = props.history,
          rest = _objectWithoutProperties(props, ["location", "history"]);

    const saveScope = (scope, pathname = location.pathname) => {
      if (pathname !== location.pathname || !scope.isEqual(location.search)) {
        history.push({
          pathname,
          search: scope.stringify()
        });
      }
    };

    const queryParam = new _queryParam.QueryParam(location, history, saveScope, processor);
    const queryProp = {
      [propName]: queryParam
    };
    return _react.default.createElement(Component, _extends({}, queryProp, rest));
  };

  WrappedComponent.propTypes = {
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string.isRequired,
      search: _propTypes.default.string.isRequired
    }),
    history: _propTypes.default.shape({
      push: _propTypes.default.func.isRequired
    })
  };
  WrappedComponent.defaultProps = {
    location: {},
    history: {}
  };
  return WrappedComponent;
}

const withQueryString = _underscore.default.compose(_verifyRouter.verifyRouter, withQueryStringInternal);

exports.withQueryString = withQueryString;

/***/ })

/******/ })});;
